import { Box } from '@mui/material'
import React, { ReactNode } from 'react'

interface IFormFooter {
  children: ReactNode
  spaceBetween?: boolean
}

const FormFooter: React.FC<IFormFooter> = ({ children, spaceBetween }) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: spaceBetween ? 'space-between' : 'flex-start',
        flexDirection: 'row-reverse',
        gap: '0.5rem',
      }}
    >
      {children}
    </Box>
  )
}

export default FormFooter
